export default "__VITE_ASSET__DXJ0HWlh__"